module.exports = __webpack_public_path__ + "img/SHK.50bb17a0.svg";